import React, { useCallback, useState } from 'react';
import {
    Button,
    StatusLabel,
    TableCell,
    TableRow,
} from '@ellucian/react-design-system/core';
import { FormattedMessage, useIntl } from 'react-intl';
import useApplicationForm from './useApplicationForm';
import { CONSTANTS } from '../Helpers/Configuration';
import SupplementalItemsUploadDialog from './SupplementalItemsUploadDialog';
import PropTypes from 'prop-types';
import HtmlFormattedMessage from '../HtmlFormattedMessage/HtmlFormattedMessage';

const SupplementalItemsTableRow = props => {
    const intl = useIntl();
    const {item, handleFormNavigate } = props;
    const { applicationFormStatuses } = CONSTANTS;
    const { previewMode, selectedLocale } = useApplicationForm();
    const { itemTypes } = CONSTANTS.supplementalItems;
    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const closeDialog = useCallback(() => {
        setOpenUploadDialog(false);
    }, [openUploadDialog]);

    const handleUploadClick = useCallback(() => {
        setOpenUploadDialog(true);
    }, [openUploadDialog]);

    return (
        <>
            <TableRow key={item.id}>
                <TableCell><FormattedMessage id={item.nameId} /></TableCell>
                <TableCell>
                    <div><HtmlFormattedMessage descriptor={{ id: item.descriptionId }} /></div>
                </TableCell>
                <TableCell><FormattedMessage id={item.required ? 'yes' : 'no'} /></TableCell>
                <TableCell>
                    {item.waived &&
                        <StatusLabel
                            text={intl.formatMessage({ id: 'supplementalItemListStatusWaived' })}
                            type={'default'}
                        />
                    }
                    {!item.waived &&
                        <StatusLabel
                            text={intl.formatMessage({ id: item.dateReceived ? 'supplementalItemListStatusReceived' : 'supplementalItemListStatusNotReceived' })}
                            type={item.received ? 'success' : 'default'}
                        />
                    }
                </TableCell>
                <TableCell>
                    {item.received && item.dateReceived ? (new Date(item.dateReceived)).toLocaleDateString(selectedLocale, { dateStyle: 'medium' }) : null}
                </TableCell>
                <TableCell>
                    {(item.itemType === itemTypes.upload || item.itemType === itemTypes.suppFormUpload) &&
                        <Button
                            disabled={previewMode}
                            onClick={handleUploadClick}
                            variant="text"
                        >
                            <FormattedMessage
                                id="supplementalItemListActionUpload"
                                values={{
                                    uploaded: Number(0).toLocaleString(selectedLocale),
                                    maxUploads: item.maxUploads ? item.maxUploads.toLocaleString(selectedLocale) : Number(0).toLocaleString(selectedLocale)
                                }}
                            />
                        </Button>
                    }
                    {(item.itemType === itemTypes.suppForm || item.itemType === itemTypes.suppFormUpload) &&
                        <Button
                            disabled={previewMode}
                            onClick={() => handleFormNavigate(item)}
                            variant="text"
                        >
                            {item.supplementalFormStatus === applicationFormStatuses.NOTSTARTED &&
                                <FormattedMessage id="supplementalItemListActionStart" />
                            }
                            {item.supplementalFormStatus === applicationFormStatuses.STARTED &&
                                <FormattedMessage id="supplementalItemListActionEdit" />
                            }
                            {item.supplementalFormStatus === applicationFormStatuses.SUBMITTED &&
                                <FormattedMessage id="supplementalItemListActionView" />
                            }
                        </Button>
                    }
                </TableCell>
            </TableRow>
            { openUploadDialog &&
                <SupplementalItemsUploadDialog
                    onClose={closeDialog}
                    itemName={item.nameId}
                    maxUploads={item.maxUploads}
                />
            }
        </>
    );
};

SupplementalItemsTableRow.propTypes = {
    item: PropTypes.object.isRequired,
    handleFormNavigate: PropTypes.func.isRequired,
};

export default SupplementalItemsTableRow;